import React, { ReactNode } from 'react';
import { Flex, cssVar } from '@cad-arc';

interface BannerContainerProps {
  children: ReactNode;
}

export const BannerContainer: React.FC<BannerContainerProps> = ({
  children,
}) => {
  return (
    <Flex direction="column" bg={cssVar('arc.colors.neutral.default')} gap="px">
        {children}
    </Flex>
  );
};
